



















import { Component, Mixins, Prop } from 'vue-property-decorator'
import BarraDePercentual from './BarraDePercentual.vue'
import CoresDoPainel from './CoresDoPainel'
import type { PosicaoRfvParaExibir } from '@/shareds/painel-do-cliente-shareds'

@Component({
	components: {
		BarraDePercentual,
	},
})
export default class PosicaoNaLojaRfv extends Mixins(CoresDoPainel) {
	@Prop({ type: Array, required: true }) posicoes!: PosicaoRfvParaExibir[]

	get posicoesLegiveis() {
		return this.posicoes.map(posicao => ({ ...posicao, cor: this.corLegivel(posicao.cor) }))
	}
}
